@if (dirty() || saving()) {
<div class="section-save-bar" role="status">
  <span
    class="section-save-bar__hint"
    data-testid="enrichment-section-unsaved-hint"
  >
    <span class="section-save-bar__dot" aria-hidden="true"></span>
    Unsaved changes@if (tabLabel()) {<span class="section-save-bar__scope">
      · {{ tabLabel() }}</span
    >}
  </span>
  @if (lockReason(); as reason) {
  <span
    class="section-save-bar__locked"
    data-testid="enrichment-section-locked-hint"
  >
    {{ reason }}
  </span>
  }
  <enr-button
    variant="text"
    size="medium"
    [disabled]="saving()"
    (clicked)="onDiscardClick()"
    [attr.data-testid]="'enrichment-section-btn-discard'"
  >
    Discard
  </enr-button>
  <enr-button
    variant="primary"
    size="medium"
    class="section-save-bar__btn"
    [disabled]="saving() || !!lockReason()"
    (clicked)="onSaveClick()"
    [attr.data-testid]="'enrichment-section-btn-save'"
  >
    {{ saving() ? "Saving…" : tabLabel() ? "Save " + tabLabel() : "Save" }}
  </enr-button>
</div>
} @else if (stageStatus(); as status) {
<!-- Save-to-stage mode: the selected price is CLEAN but not yet staged
     (In design / Rejected) — the BE advances it to Designed on any save,
     and without this the bar would never appear for such a price. -->
<div class="section-save-bar section-save-bar--stage" role="status">
  <span
    class="section-save-bar__hint section-save-bar__hint--stage"
    data-testid="enrichment-section-stage-hint"
  >
    <span
      class="section-save-bar__dot section-save-bar__dot--stage"
      aria-hidden="true"
    ></span>
    Not publishable yet<span class="section-save-bar__scope">
      · {{ status }}</span
    >
  </span>
  @if (lockReason(); as reason) {
  <span
    class="section-save-bar__locked"
    data-testid="enrichment-section-locked-hint"
  >
    {{ reason }}
  </span>
  }
  <enr-button
    variant="primary"
    size="medium"
    class="section-save-bar__btn"
    [disabled]="!!lockReason()"
    (clicked)="onStageClick()"
    [attr.data-testid]="'enrichment-section-btn-stage'"
  >
    Save to stage
  </enr-button>
</div>
}
